import { render, staticRenderFns } from "./CoozzyCard.vue?vue&type=template&id=23c0236c&scoped=true"
import script from "./CoozzyCard.vue?vue&type=script&lang=js"
export * from "./CoozzyCard.vue?vue&type=script&lang=js"
import style0 from "./CoozzyCard.vue?vue&type=style&index=0&id=23c0236c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c0236c",
  null
  
)

export default component.exports